<div id="optionsCalculatorForm">

  <ngx-spinner
    [fullScreen]="false"
    bdColor="rgba(51,51,51,0.1)"
    bdOpacity=0.5
    color="#fff"
    name=futuresCalculatorSpinner
    size="medium"
    type="ball-spin-clockwise"
  >
    <p style="color: white"></p>
  </ngx-spinner>

  <iv-live-common-calculator
    (changeInstrument)="changeFuture($event); inputHandler($event)"
    (goButtonClicked)="onGoButtonClick($event)"
    (hideSpinnerEvent)="hideSpinner('futuresCalculatorSpinner')"
    (keyDownSearch)="keyDownSearch($event)"
    (modeClicked)="onModeChanged($event)"
    (returnRegionEvent)="returnRegion($event)"
    (showSpinnerEvent)="showSpinner()"
    [autocompletePlaceholder]="'Future or Option Symbol...'"
    [instruments]="futures"
    [regionId]="regionId"
    [stockSearchCriteria]="future?.underlyingid || future?.underlyingId"
    [stockName]="future?.nameAndExchange || future?.stockName || future?.underlyingId"
    [value]="future?.value"
  >

    <form (ngSubmit)="calculate()" [formGroup]="calculatorForm" class="calculator-body">

      <div class="parameters">
        <!-- Заглушка, которая занимает место для search (вынужденное решение в связи с предыдущей реализацией) -->
        <div class="param" style="opacity:0; visibility: hidden;">
          <span class="param-label"></span>
          <span class="param-value"></span>
        </div>
        <div class="param">
          <span class="param-label with-tip">FutExp
            <span class="tip">Ending date of the Futures contract</span>
          </span>
          <iv-live-dropdown
            (closeOtherDropdown)="openDropdown(0)"
            (scroll)="onScroll($event)"
            (selectedDataChange)="selectFutExpiration($event)"
            [cssClass]="'param-value param-value-style'"
            [data]="getArrayFromObject(futureExpirations)"
            [label]=""
            [selectedData]="futExpDate"
            [type]="getTypeDropDown()"
            data-id="expirations"
          >
          </iv-live-dropdown>
        </div>

        <div class="param">
        <span class="param-label with-tip">FutSym
          <span class="tip">A shorthand symbol to easily identify contracts traded, that consists of three parts: the root symbol, the year code, and the month code</span>
        </span>
          <input readonly (keydown)="keyDown($event)" class="param-value" [(ngModel)]="futSymbol" [ngModelOptions]="{standalone: true}">
        </div>

        <div class="param">
        <span class="param-label with-tip">Style
          <span class="tip">An option's style can be American (Amer), European (Euro), or exotic.
            Euro options can only be exercised on the expiration,
            whereas Amer options can be exercised at any point before expiration</span>
        </span>
          <iv-live-dropdown
            (closeOtherDropdown)="openDropdown(1)"
            (selectedDataChange)="selectStyle($event)"
            [(selectedData)]="styleName"
            [cssClass]="'param-value param-value-style'"
            [data]="getArrayFromObject(styles)"
            [label]=""
            [valueAttribute]="'name'"
            data-id="style"
          >
          </iv-live-dropdown>

        </div>

        <div class="param">
        <span class="param-label with-tip">Last Price
          <span class="tip">Futures Last Price</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)"
            (keydown)="keyDown($event)"
            [(ngModel)]="price"
            (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            pattern="[0-9]"
            class="param-value"
            data-id="price">
        </div>

        <div class="param">
        <span class="param-label with-tip">Strike
          <span class="tip">Strike price is the stated price per future for which the underlying futures may be purchased (in the case of a call) or sold (in the case of a put) by the option holder upon exercise of the option</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)" [(ngModel)]="priceStrike" (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}" class="param-value" data-id="stike">
        </div>

        <div class="param">
        <span class="param-label with-tip">Expiry
          <span class="tip">Option expiry; closest expiry set by default</span>
        </span>
          <div style="display: flex;">
            <iv-live-dropdown
              (closeOtherDropdown)="openDropdown(2)"
              (scroll)="onScroll($event)"
              (selectedDataChange)="selectOptExpiration($event)"
              [cssClass]="'param-value param-value-style'"
              [data]="getArrayFromObject(expirations)"
              [label]=""
              [(selectedData)]="expDate"
              [type]="getTypeDropDown()"
              [valueAttribute]="'expDate'"
              [dropdownOffset]="{'top': 'auto', 'bottom': '36px'}"
              data-id="optFutureExpirations"
            >
            </iv-live-dropdown>
          </div>
        </div>

        <div class="param">
        <span class="param-label with-tip">DTE
          <span class="tip">Days to Expiration</span>
        </span>
          <div class="time-values">
            <input
              (input)="onExpValueInput($event, 'daysToExp');inputHandler($event)" (keydown)="keyDown($event)"
              class="param-value" data-id="daysToExp"
              value="{{daysToExp}}">
          </div>
        </div>

        <div class="param">
        <span class="param-label with-tip">IV
          <span class="tip">Implied Volatility is the market's estimate of future volatility.
            In simple terms, it is derived from the options' bid/ask data</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)" [(ngModel)]="Vola" (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            class="param-value" data-id="vola">
        </div>
        <div class="param">
        <span class="param-label with-tip">IntRate
          <span class="tip">The interest rate used is derived from last night's treasury market and is
            interpolated to conform to option's expiration term.
            We take OIS SOFR for terms up to one year inclusive and ISDA (R)
            Swaps IR par mid rate for terms above one year</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)" [(ngModel)]="rate" (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            class="param-value" data-id="vola">
        </div>

      </div>

      <!-- <div class="calc-button">
        <iv-live-image-button
          (buttonClicked)="calculateOption()"
        >
          <img src="data:image/png;base64,
iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABlQAAAZUBDE2OiAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGwSURBVEiJ1ZW/TttQFIe/Y5BIllZhqdgAiYFOleAl2qENCeQVMlQqqkSBBflGoqUIUNW8AHuUAFVR+hBVy0QqdYCNBYlsFRV/DktsX8uOYyMWftP1Odff75zr63vhsUsSs+36CP8uFoA5hBdAoZfpAkeI7JMrNHn17n92g5aZB7aA8QFFniIsUTJ76QwajSGGOzsoiwPAYSlfuH3+gUrlxg4PRyY6na8obzPBAYT3OJ0hCBcW7qBpigj7meGBFJU3zLvfowa7JscT/jB4zQfplPzotPfhHT/8lGIG+GZCboLL7mvvITBQiqlrLJvVRBNVn+VY4ZnUBoFJLTYnAcveRc9iIMk/YtkYWiYHrITit4x5Q7sDh/tIpBuNBZvH7uAMmApNbBmNhXqd7dVWUP0cY3DmDe2qf6cp2Fc/OIDyK2ogHDwIHEDEZwUG52Mt4G8qgyQ4HHM97R98gUG1eoXIMhC/7umkCKv2gRfeOSX3G4h7f7ysUTKHdii6NUvuOrCRGS58pOx+iob7qVkrI7rNg184ttr1ES4v5lBeIsyiTPbeOgF+ovKDfOEg6cp8/LoDCjl1+5gy0b0AAAAASUVORK5CYII=
      ">
        </iv-live-image-button>

      </div> -->
      <div class="calculator-result">

        <div class="calculator-result-row" style="margin-bottom:-16px">
            <span></span>
            <span class="calculator-result-type result-type-with-border">Call</span>
            <span class="calculator-result-type">Put</span>
        </div>

        <div class="calculator-result-row">
          <span class="with-tip">OptValue<span
            class="tip">The Option Value calculated by IVolatility calculation engine</span></span>
          <span class="result-value" data-id="optValue">{{result?.optValue| number:'1.4'}}</span>
          <span class="result-value" data-id="optValuePut">{{result?.optValuePut| number:'1.4'}}</span>
        </div>

        <div class="calculator-result-row">
          <span class="with-tip">Delta<span class="tip">Delta. (Greek) Change of an option's price relative to a $1 change in the underlying's price</span></span>
          <ng-container *ngIf="loading == false">
            <span class="result-value" data-id="deltaCall">{{result?.deltaCall| number:'1.4'}}</span>
            <span class="result-value" data-id="deltaPut">{{result?.deltaPut| number:'1.4'}}</span>
          </ng-container>
          <ng-container *ngIf="loading == true">
            <div>
              <img src="/src/iv-live/assets/form_loading.gif"/>
            </div>
          </ng-container>
        </div>

        <div class="calculator-result-row">
          <span class="with-tip">Gamma
          <span class="tip">Gamma. (Greek) Change of Delta relative to a $1 change in the underlying's price</span></span>
          <span class="result-value" data-id="gammaCall">{{result?.gammaCall| number:'1.4'}}</span>
          <span class="result-value" data-id="gammaPut">{{result?.gammaPut| number:'1.4'}}</span>
        </div>

        <div class="calculator-result-row">
          <span class="with-tip">Theta
            <span class="tip">Theta. (Greek) Loss of an option's
              value relative to a one day decrease in time to expiration (time decay)</span>
          </span>
          <span class="result-value" data-id="thetaCall">{{result?.thetaCall| number:'1.4'}}</span>
          <span class="result-value" data-id="thetaPut">{{result?.thetaPut| number:'1.4'}}</span>
        </div>

        <div class="calculator-result-row">
          <span class="with-tip">Vega<span class="tip">Vega. (Greek) Change of an option's price relative
              to a 1% (absolute) change in its implied volatility</span></span>
          <span class="result-value" data-id="vegaCall">{{result?.vegaCall| number:'1.4'}}</span>
          <span class="result-value" data-id="vegPut">{{result?.vegPut| number:'1.4'}}</span>
        </div>

      </div>
    </form>

    <div class="iv-calculator-form">
      <div class="opt-price">
        <span class="opt-price-label">Opt Price</span>
        <input
          (input)="onlyNumbersPaste($event)"
          (ngModelChange)="changeOptPrice()"
          [(ngModel)]="optionPrice"
          [class.isEmpty]="optPriceIsEmpty"
          [ngModelOptions]="{standalone: true}"
          class=" opt-price__input"
          data-id="optionPrice"
        >
      </div>

      <div class="calculator-result">
        <div class="calculator-result-row">
          <div class="iv-calculator-result__label">
            Implied Volatility
          </div>
          <span *ngIf="calculatedIVCall" class="with-tip"
            data-id="calculatedIV">
            {{calculatedIVCall * 100 | number:'1.0-2'}}
            <span class="tip">
              Implied Volatility is the market's estimate of future volatility.
              In simple terms, it is derived from the options' bid/ask data
            </span>
          </span>

          <span *ngIf="calculatedIVPut" class="with-tip"
            data-id="calculatedIV">
            {{calculatedIVPut * 100 | number:'1.0-2'}}
            <span class="tip">
              Implied Volatility is the market's estimate of future volatility.
              In simple terms, it is derived from the options' bid/ask data
            </span>
          </span>
        </div>
      </div>

    </div>
  </iv-live-common-calculator>
</div>
